import { observer } from 'mobx-react-lite';

import { stanzone } from '^/__generated__/pothosZod/generated_models';
import { CowStanzoneTypeT } from '^/types/CowStanzoneType';

export const StanzonePushSentTypeView: React.FC<{
  eventTime: Date,
  stanzone: CowStanzoneTypeT,
}> = observer(function StanzonePushSentTypeView(p) {
  const { pushType } = p.stanzone;
  if (pushType === 'JUST_UNLOCKED') {
    return (
      <div>
        {p.eventTime.toLocaleString()} 에 잠금 해제됨
      </div>
    );
  }
  const statusStartTime = p.stanzone.sameStatusSince;
  const millisecDiff = statusStartTime && (

    p.stanzone.createdAt.getTime() - statusStartTime.getTime()
    || 0);
  const minDiff = ((millisecDiff || -1) / (1000 * 60))
    .toFixed(0);
  if (
    pushType === 'LOCKED_FOR_TOO_LONG'
  ) {
    return (
      <div>

        🚨잠김 {minDiff} 분 경과 🚨
        <br />
        {statusStartTime?.toLocaleString()} 부터 잠겼습니다
      </div>
    );
  }
  if (
    pushType === 'CAM_DETECTION_OFFLINE'
  ) {
    return (
      <div>
        🚨기기 오프라인 {minDiff} 분 경과 🚨
        <br />
        {p.stanzone.createdAt.toLocaleString()} 부터 데이터가 오지 않습니다
      </div>
    );
  }

  if (
    pushType === 'NOT_SENT_YET'
  ) {
    return (
      <div>
        처리예정 푸쉬입니다
      </div>
    );
  }

  if (
    pushType === 'NO_NEED_TO_SEND'
  ) {
    return (
      <div>
        (알림 상황 아님)
      </div>
    );
  }

  const exhaustive: never = pushType;
  return (
    <div>
      [StanzonePushSentTypeView] {exhaustive}: 뷰 구현이 되지 않은 푸쉬 타입입니다
    </div>
  );
});
